import { useState } from "react";
import { toast } from "sonner";
import { Phone, Truck } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { Button } from "./ui/button";

export default function DeliveryInfoForm({ order, onSaved }) {
  const { user } = useAuth();
  const cur = order.delivery_info || {};
  const [name, setName] = useState(cur.delivery_contact_name || user?.default_delivery_contact_name || "");
  const [phone, setPhone] = useState(cur.delivery_contact_phone || user?.default_delivery_contact_phone || "");
  const [instr, setInstr] = useState(cur.unloading_instructions || user?.default_unloading_instructions || "");
  const [busy, setBusy] = useState(false);
  const dirty = name !== (cur.delivery_contact_name || "") || phone !== (cur.delivery_contact_phone || "") || instr !== (cur.unloading_instructions || "");
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.patch(`/orders/${order.id}/delivery-info`, { delivery_contact_name: name, delivery_contact_phone: phone, unloading_instructions: instr, save_as_default: true });
      toast.success("Dati consegna salvati");
      onSaved?.(data);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <div className="rounded-xl border border-slate-200 bg-slate-50 p-3 space-y-2" data-testid="delivery-info-form">
      <div className="text-xs font-mono uppercase tracking-widest text-slate-500 flex items-center gap-1.5"><Truck className="w-3.5 h-3.5" /> Contatto consegna e scarico</div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        <div><Label className="text-xs">Referente in loco</Label><Input value={name} onChange={e => setName(e.target.value)} placeholder="Es. Marco (cucina)" data-testid="delivery-contact-name" /></div>
        <div><Label className="text-xs">Telefono referente</Label><Input type="tel" value={phone} onChange={e => setPhone(e.target.value)} placeholder="+39 3XX XXXXXXX" data-testid="delivery-contact-phone" /></div>
      </div>
      <div><Label className="text-xs">Istruzioni per lo scarico</Label><Textarea rows={2} value={instr} onChange={e => setInstr(e.target.value)} placeholder="Es. ingresso merci sul retro, citofono 'Cucina', orario 7–10, cella frigo al piano -1" data-testid="unloading-instructions" /></div>
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <div className="text-[11px] text-slate-500 inline-flex items-center gap-1"><Phone className="w-3 h-3" /> Il fornitore vede telefono e istruzioni solo dopo il pagamento. Salvati come predefiniti per i prossimi ordini.</div>
        <Button type="button" size="sm" variant="outline" className="rounded-full" disabled={busy || !dirty} onClick={save} data-testid="delivery-info-save">{busy ? "..." : "Salva dati consegna"}</Button>
      </div>
    </div>
  );
}
